/**
 * Header.
 * Sticky Header.
 * */

import Headroom from 'headroom.js';

export default {
  init() {
    /* Stiky Header */
    let header = document.querySelector("header");
    let headroom  = new Headroom(header, {
      offset : 120,
      treshold : 5,
      onPin : function() {
        $(header).addClass('has-pinned');
        $('body').removeClass('menu-hovered');
        $(header).removeClass('headroom--pre-close');

      },
      onTop : function() {
        $(header).removeClass('has-pinned');
        $(header).removeClass('headroom--pre-close');
      },
    });
    headroom.init();

    $('.nav-menu__item').hover(
      function() {
        $('body').addClass('menu-hovered');
      },
      function() {
        $('body').removeClass('menu-hovered');
      }
    );

    var eTop = $('body').offset().top; //get the offset top of the element
    $(window).on('scroll', function() {
      if( $('.headroom--pre-close').length ) {
        return;
      }

      if( eTop - $(window).scrollTop() > -150 ) {
        $('.headroom--not-top').addClass('headroom--pre-close');
      }
    });
    /**
     * Prevent following link on click (touch screen devices need to open menu)
     */
    $('.nav-menu__link').on('click', function(e) {
      if( $(this).next('.nav-menu__child').length ) {
        e.preventDefault();
     }
    });

    $('.nav-menu__link--has-children').on('touchstart', function(e) {
      e.preventDefault();
      $('.nav-menu__link--has-children').parent('.nav-menu__child-item').addClass('nav-menu__child-item--active');
    });

  },

}



// WEBPACK FOOTER //
// ./scripts/lib/header.js